import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthorizationService } from '../../services/authorization.service';
import { RolesService } from '../../services/roles.service';
import { HomeService } from '../../services/home.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit {
  title = 'Home';
  devMode: boolean = false;
  public baseUrl: string;

  Roles: string[] = [];
  inRoleAdmin: boolean = false;
  inRoleSuper: boolean = false;

  constructor(private RolesService: RolesService, private HomeService: HomeService, private authorizationService: AuthorizationService, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  ngOnInit() {
    if (this.baseUrl.indexOf("localhost") > -1) {
      this.devMode = true;
    }
    //    this.getRolesList();
  }

  getRolesList() {
    this.RolesService.getRolesList()
      .subscribe(
        result => {
          this.Roles = result;
          this.inRoleSuper = this.Roles.includes("Super");
          this.inRoleAdmin = this.Roles.includes("Admin");
        },
        error => {
          console.log(error);
        }
      );
  }

 
}
